import { Component, Input, OnInit } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { ResolverService } from "../../../../core/services/resolver/resolver.service";
import { Initials } from "../../../../core/models/initials.model";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { MatDialog } from "@angular/material/dialog";
import { LoaderService } from "src/app/core/services/loader/loader.service";
@Component({
  selector: "app-online-payment-invoice-print",
  templateUrl: "./online-payment-invoice-print.component.html",
  styleUrls: ["./online-payment-invoice-print.component.scss"],
})
export class OnlinePaymentInvoicePrintComponent implements OnInit {
  @Input() invoiceData;
  environmentConfig = environment;
  userInit: Initials;
  todayDate = new Date().toISOString();
  constructor(
    private resolverService: ResolverService,
    private dialog: MatDialog,
    private loaderService: LoaderService
  ) {
    this.userInit = this.resolverService.userInitInfo;
  }

  ngOnInit(): void {}

  public downloadAsPDF() {
    this.loaderService.show();
    const element = document.getElementById("print-section") as HTMLElement;
    element.style.display = "block";
    const DATA: any = document.getElementById("print-section");

    html2canvas(DATA, {
      scale: window.innerWidth < 768 ? 1 : 2,
      useCORS: true,
      width: DATA.scrollWidth,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.7);
      const imgWidth = 210;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      const pdf = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: "a4",
        compress: true,
      });

      let position = 0;
      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      if (imgHeight > pageHeight) {
        pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, pageHeight);
      } else {
        pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
      }
      element.style.display = "none";
      this.loaderService.hide();
      pdf.save("bank-transfer_invoice.pdf");
      this.dialog.closeAll();
    });
  }
}
